import { useCallback, useMemo } from 'react';

import { useDefaultEvents, useGrid } from '@Components/Grid';

export default function useEvents() {
  const { store: { disableAuthentication }, handleRefresh } = useGrid()
  const { handleDeleteEntry, handleUpdateEntry } = useDefaultEvents()

  const handleUpdate2FA = useCallback(async id => {
    await disableAuthentication(id)
    await handleRefresh()
  }, [disableAuthentication, handleRefresh])

  return useMemo(() => ({
    handleUpdateEntry,
    handleDeleteEntry,
    handleUpdate2FA,
  }), [handleUpdateEntry, handleDeleteEntry, handleUpdate2FA])
}
